// extracted by mini-css-extract-plugin
module.exports = {"web-player":"_1xO3DPRhNZ-DuMHYhmifsk"};